// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "hash": "fe86b93",
    "fullHash": "fe86b93a26220197f7a9d8e533b17b6f933e8195",
    "branch": "HEAD",
    "tag": null
};
/* tslint:enable */
/* eslint-enable */
